import React, { useEffect } from "react";
import { PageLayout } from "../../components/PageLayout";
import axios from "axios";

import ReactLoading from "react-loading";
import { Renderer } from "../../Renderer";
import toml from "@iarna/toml";
import { validate } from "../../validator";
import { useGistStateValue } from "./context";
import { actions } from "./reducer";
import { navigate } from "@reach/router";

export const GistParam = props => {
  const { gistId } = props;
  const [state, dispatch] = useGistStateValue();

  useEffect(() => {
    getGistContent(gistId).then(
      gistContent => dispatch(actions.setContent(gistContent)),
      err => {
        dispatch(actions.setError(err.message));
        navigate("/gist");
      }
    );
  }, [gistId]);

  const renderContent = () => {
    if (!state.content) {
      return (
        <div className="h-full bg-black flex items-center justify-center">
          <ReactLoading type="spin" color="#fff" />
        </div>
      );
    } else {
      return (
        <div className="h-full flex">
          <Renderer resume={state.content} />
        </div>
      );
    }
  };

  return (
    <PageLayout title="TOML Resume Renderer">{renderContent()}</PageLayout>
  );
};

async function getGistContent(gistId) {
  let content;
  let parsed;

  try {
    const response = await axios.get(
      `https://api.github.com/gists/${gistId}?nocache=${randomString()}`
    );
    const files = response.data.files;
    content = files[Object.keys(files)[0]].content;
  } catch (err) {
    if (err && err.response && err.response.status === 404) {
      throw new Error("Could not find gist with this ID");
    } else {
      throw new Error("Problem fetching gist");
    }
  }

  try {
    parsed = toml.parse(content);
  } catch (err) {
    throw new Error("Invalid TOML");
  }

  const validationErrors = validate(parsed);

  if (validationErrors) {
    console.log(">>>", validationErrors);
    throw new Error(`Invalid resume: ${validationErrors[0].message}`);
  }

  return parsed;
}

function randomString() {
  return (Math.random() * 1000000 + "").split(".")[0];
}
